import Keycloak from 'keycloak-js'
import getEnvFromLocation from './getEnvFromLocation'

const REALMS = {
  local: 'insights_dev',
  test: 'insights_dev',
  development: 'insights_dev',
  staging: 'insights_prod',
  production: 'insights_prod',
}

const CLIENT_IDS = {
  local: 'insights-test-env',
  test: 'insights-test-env',
  development: 'insights-dev',
  staging: 'insights-stag',
  production: 'insights-prod',
}

const ENDPOINT = {
  local: 'https://login.dev.insights.winnin.com/auth/',
  test: 'https://login.dev.insights.winnin.com/auth/',
  development: 'https://login.dev.insights.winnin.com/auth/',
  staging: 'https://login-insights.winnin.com/auth/',
  production: 'https://login-insights.winnin.com/auth/',
}

const env = getEnvFromLocation()

const keycloak = new (Keycloak as any)({
  url: ENDPOINT[env],
  realm: REALMS[env],
  clientId: CLIENT_IDS[env],
})

keycloak.createLogoutUrl = function(options: any) {
  return keycloak.endpoints.logout()
      + '?id_token_hint=' + keycloak.idToken
      + '&post_logout_redirect_uri=' + encodeURIComponent(window.location.href);
}

const keycloakProviderProps = {
  authClient: keycloak,
  initOptions: {
    onLoad: 'check-sso',
    // enableLogging: true,
  },
}

export {
  REALMS,
  keycloak,
  keycloakProviderProps,
}
